import { MimeType } from './mime-type.enum';

export const mimeTypeIcons = {
  // Default mime-types
  default: 'fa-file-o',
  'image-default': 'fa-file-image-o',
  'video-default': 'fa-file-video-o',
  'audio-default': 'fa-file-audio-o',

  // PDF mime-type
  [MimeType.APPLICATION_PDF]: 'fa-file-pdf-o',

  // Code mime-types
  [MimeType.TEXT_HTML]: 'fa-file-code-o',
  [MimeType.APPLICATION_JSON]: 'fa-file-code-o',
  [MimeType.APPLICATION_X_JAVASCRIPT]: 'fa-file-code-o',

  // Text mime-types
  [MimeType.TEXT_PLAIN]: 'fa-file-text-o',
  [MimeType.APPLICATION_RTF]: 'fa-file-text-o',
  [MimeType.TEXT_RICHTEXT]: 'fa-file-text-o',

  // Archive mime-types
  [MimeType.APPLICATION_X_GZIP]: 'fa-file-archive-o',
  [MimeType.APPLICATION_GZIP]: 'fa-file-archive-o',
  [MimeType.APPLICATION_X_COMPRESSED]: 'fa-file-archive-o',
  [MimeType.APPLICATION_X_ZIP_COMPRESSED]: 'fa-file-archive-o',
  [MimeType.APPLICATION_ZIP]: 'fa-file-archive-o',
  [MimeType.APPLICATION_X_TAR]: 'fa-file-archive-o',
  [MimeType.APPLICATION_JAVA_ARCHIVE]: 'fa-file-archive-o',
  [MimeType.MULTIPART_X_ZIP]: 'fa-file-archive-o',
  [MimeType.MULTIPART_X_GZIP]: 'fa-file-archive-o',

  // MSWord mime-types
  [MimeType.APPLICATION_MSWORD]: 'fa-file-word-o',
  [MimeType.APPLICATION_VND_OPENXMLFORMATS_OFFICEDOCUMENT_WORDPROCESSINGML_DOCUMENT]: 'fa-file-word-o',
  [MimeType.APPLICATION_VND_OPENXMLFORMATS_OFFICEDOCUMENT_WORDPROCESSINGML_TEMPLATE]: 'fa-file-word-o',
  [MimeType.APPLICATION_VND_MS_WORD_DOCUMENT_MACROENABLED_12]: 'fa-file-word-o',
  [MimeType.APPLICATION_VND_MS_WORD_TEMPLATE_MACROENABLED_12]: 'fa-file-word-o',

  // Excel mime-types
  [MimeType.APPLICATION_MSEXCEL]: 'fa-file-excel-o',
  [MimeType.APPLICATION_VND_MS_EXCEL]: 'fa-file-excel-o',
  [MimeType.APPLICATION_VND_OPENXMLFORMATS_OFFICEDOCUMENT_SPREADSHEETML_SHEET]: 'fa-file-excel-o',
  [MimeType.APPLICATION_VND_OPENXMLFORMATS_OFFICEDOCUMENT_SPREADSHEETML_TEMPLATE]: 'fa-file-excel-o',
  [MimeType.APPLICATION_VND_MS_EXCEL_SHEET_MACROENABLED_12]: 'fa-file-excel-o',
  [MimeType.APPLICATION_VND_MS_EXCEL_TEMPLATE_MACROENABLED_12]: 'fa-file-excel-o',
  [MimeType.APPLICATION_VND_MS_EXCEL_ADDIN_MACROENABLED_12]: 'fa-file-excel-o',
  [MimeType.APPLICATION_VND_MS_EXCEL_SHEET_BINARY_MACROENABLED_12]: 'fa-file-excel-o',

  // Powerpoint mime-types
  [MimeType.APPLICATION_MSPOWERPOINT]: 'fa-file-powerpoint-o',
  [MimeType.APPLICATION_VND_MS_POWERPOINT]: 'fa-file-powerpoint-o',
  [MimeType.APPLICATION_VND_OPENXMLFORMATS_OFFICEDOCUMENT_PRESENTATIONML_PRESENTATION]: 'fa-file-powerpoint-o',
  [MimeType.APPLICATION_VND_OPENXMLFORMATS_OFFICEDOCUMENT_PRESENTATIONML_TEMPLATE]: 'fa-file-powerpoint-o',
  [MimeType.APPLICATION_VND_OPENXMLFORMATS_OFFICEDOCUMENT_PRESENTATIONML_SLIDESHOW]: 'fa-file-powerpoint-o',
  [MimeType.APPLICATION_VND_MS_POWERPOINT_ADDIN_MACROENABLED_12]: 'fa-file-powerpoint-o',
  [MimeType.APPLICATION_VND_MS_POWERPOINT_PRESENTATION_MACROENABLED_12]: 'fa-file-powerpoint-o',
  [MimeType.APPLICATION_VND_MS_POWERPOINT_SLIDESHOW_MACROENABLED_12]: 'fa-file-powerpoint-o',

  // Image mime-types
  [MimeType.IMAGE_PNG]: 'fa-file-image-o',
  [MimeType.IMAGE_JPG]: 'fa-file-image-o',
  [MimeType.IMAGE_JPEG]: 'fa-file-image-o',
  [MimeType.IMAGE_SVG_XML]: 'fa-file-image-o',
  [MimeType.IMAGE_GIF]: 'fa-file-image-o',


  // Video mime-types
  [MimeType.APPLICATION_ANNODEX]: 'fa-file-video-o',
  [MimeType.APPLICATION_MP4]: 'fa-file-video-o',
  [MimeType.APPLICATION_OGG]: 'fa-file-video-o',
  [MimeType.APPLICATION_OCTET_STREAM]: 'fa-file-video-o',
  [MimeType.APPLICATION_VND_RN_REALMEDIA]: 'fa-file-video-o',
  [MimeType.APPLICATION_X_MATROSKA]: 'fa-file-video-o',
  [MimeType.APPLICATION_X_TROFF_MSVIDEO]: 'fa-file-video-o',
  [MimeType.VIDEO_QUICKTIME]: 'fa-file-video-o',
  [MimeType.VIDEO_MP4]: 'fa-file-video-o',

  // Audio mime-types
  [MimeType.AUDIO_X_WAV]: 'fa-file-audio-o',
  [MimeType.AUDIO_MPEG]: 'fa-file-audio-o', // MimeType for MP3 extension.
  [MimeType.AUDIO_OGG] : 'fa-file-audio-o',
  [MimeType.AUDIO_WAV]: 'fa-file-audio-o',
  [MimeType.AUDIO_VND_WAVE]: 'fa-file-audio-o'
};
